﻿import {isNullOrEmpty} from "@2d-front-monorepo/core";
import {PermitId, Permits, Residencies, ResidencyId} from "@2d-front-monorepo/permits-business";

import {JSX} from "react";
import {useSearchParams} from "react-router";
import Registrations from "../../customers/Registrations";
import {usePermits} from "../../hooks/usePermits";

export default function CreateResidency(): JSX.Element {
	const [searchParams] = useSearchParams();
	const {permits, holderData} = usePermits();

	const permitId = searchParams.get("permitId") as PermitId;
	const residencyId = searchParams.get("residencyId") as ResidencyId;

	const permit = isNullOrEmpty(permitId) ? undefined : Permits.find(permits, permitId);
	const residency = isNullOrEmpty(residencyId) ? undefined : Residencies.get(permits, residencyId);

	const EditComponent = Registrations.getCreateResidency();
	return <EditComponent holderData={holderData} permits={permits} permit={permit} residency={residency}/>;
}
